import PremiumTemplate, { type WebsiteCustomizations } from "./PremiumTemplate";
import EcommerceTemplate from "./EcommerceTemplate";
import PortfolioTemplate from "./PortfolioTemplate";
import RestaurantTemplate from "./RestaurantTemplate";
import SaasTemplate from "./SaasTemplate";
import ArtisanTemplate from "./ArtisanTemplate";
import ConsultantRdvTemplate from "./ConsultantRdvTemplate";
// Premium templates (Sprint 1 — Base44-grade)
import LibrairieTemplate from "./LibrairieTemplate";
import ImmobilierLuxePremiumTemplate from "./ImmobilierLuxePremiumTemplate";
import SaasYCTemplate from "./SaasYCTemplate";
import AvocatTemplate from "./AvocatTemplate";
import PortfolioPremiumTemplate from "./PortfolioPremiumTemplate";

interface Props {
  templateId: string;
  name: string;
  desc: string;
  product: string;
  client: string;
  city: string;
  sector: string;
  customizations?: WebsiteCustomizations;
  editMode?: boolean;
  onCustomize?: (field: keyof WebsiteCustomizations, value: string) => void;
}

const TemplateRenderer = ({ templateId, name, desc, product, client, city, sector, customizations, editMode, onCustomize }: Props) => {
  const shared = { name, desc, product, city, customizations, editMode, onCustomize };
  switch (templateId) {
    case "wix-consultant-rdv":
      return <ConsultantRdvTemplate {...shared} />;
    // Premium series
    case "librairie":
      return <LibrairieTemplate {...shared} />;
    case "immobilier-luxe-premium":
      return <ImmobilierLuxePremiumTemplate {...shared} />;
    case "saas-yc":
      return <SaasYCTemplate {...shared} product={product} />;
    case "avocat":
      return <AvocatTemplate {...shared} />;
    case "portfolio-premium":
      return <PortfolioPremiumTemplate {...shared} product={product} />;
    // Legacy templates
    case "ecommerce":
      return <EcommerceTemplate {...shared} />;
    case "portfolio":
      return <PortfolioTemplate {...shared} />;
    case "restaurant":
      return <RestaurantTemplate {...shared} />;
    case "saas":
      return <SaasTemplate {...shared} />;
    case "artisan":
      return <ArtisanTemplate {...shared} />;
    case "premium":
    default:
      return (
        <PremiumTemplate
          {...shared}
          client={client}
          sector={sector}
        />
      );
  }
};

export default TemplateRenderer;
